var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-input"},[_c('button',{on:{"click":_vm.add}},[_vm._v("Add")]),_c('button',{on:{"click":_vm.remove}},[_vm._v("Remove")])])}
var staticRenderFns = []

export { render, staticRenderFns }